import getDefaultFocusedViewFilterForSelectedFolder from '../utils/FocusedInboxUtil';
import { getFindConversationShape, getFindItemShape } from 'owa-mail-store';
import { MailSortHelper, } from 'owa-mail-list-store';
/**
 * Create the table query to load a mail folder
 * @param folderId the folderId
 * @param listViewType the list view type
 * @param scenarioType the type of scenario
 * @param focusedViewfilter the focusedViewfilter
 * @param viewFilter the viewFilter
 * @param categoryName the category name [this will have a value when create query for a category table]
 * @param sortBy the sortBy (column and direction)
 * @return tableQuery the tableQuery that needed to load a mail folder
 */
export default function createMailFolderTableQuery(folderId, listViewType, scenarioType, focusedViewFilter, viewFilter, categoryName, sortBy) {
    var viewFilterToSet = viewFilter ? viewFilter : 'All';
    var sortByToSet = sortBy ? sortBy : MailSortHelper.getDefaultSortBy();
    var focusedViewFilterToSet = focusedViewFilter == null
        ? getDefaultFocusedViewFilterForSelectedFolder(folderId)
        : focusedViewFilter;
    var requestShapeName;
    switch (listViewType) {
        case 0 /* Conversation */:
            requestShapeName = getFindConversationShape(folderId);
            break;
        case 1 /* Message */:
            requestShapeName = getFindItemShape();
            break;
    }
    var folderTableQuery = {
        folderId: folderId,
        focusedViewFilter: focusedViewFilterToSet,
        listViewType: listViewType,
        viewFilter: viewFilterToSet,
        sortBy: sortByToSet,
        requestShapeName: requestShapeName,
        type: 0 /* Folder */,
        shouldTryToUseSessionDataResponse: true,
        categoryName: categoryName,
        scenarioType: scenarioType,
    };
    return folderTableQuery;
}
//# sourceMappingURL=createMailFolderTableQuery.js.map